import $ from 'jquery'
import { trace } from 'rytm-helpers'

const FORM_GROUP_SELECTOR = ".form-group, .formfield"
const CLASS_NAME_ERROR = "validation-error"
const CLASS_NAME_OK = "validation-ok"

/**
 * ###############
 * ### Helpers ###
 */
const isEmail = ( txt ) => {
  let regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test( txt );
}
const isSafe = ( txt ) => {
  // let regex = /[\-\[\]\/\{\}\(\)\*\<\>\+\?\.\\\^\$\|]/g;
  // let regex = /[\-\[\]\{\}\(\)\*\<\>\+\?\.\\\^\$\|]/g;
  let regex = /[\-\[\]\{\}\(\)\*\<\>\+\?\\\^\$\|]/g;
  return !regex.test( txt );
}

// Zwraca wszystkie pola
const getInputElements = ( wrapper ) => {
  return [...wrapper.querySelectorAll("input, textarea, select")]
}
// Waliduje pojedynczy element (input / select / textarea)
const validateInput = ( inpt ) => {
  let isValid = true  
  switch (inpt.type) {
    case "checkbox":
      if (inpt.required && !inpt.checked) {
        isValid = false
      }
      break;
    case "email":
      if (inpt.required || inpt.value) {
        if (!isEmail(inpt.value)) {
          isValid = false
        }
      }
      break;
    default:
      if (inpt.required && !inpt.value) {
        isValid = false
      } else if (inpt.name == "numer-telefonu") {
        if (inpt.value) {
          // validate telephone number
          const re = /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im
          if (!re.test(inpt.value)) {
            isValid = false
          }
        } else if (inpt.required) {
          isValid = false
        }
      }
      break;
  }
  
  return isValid
}

// odznacz element oraz rodzica jako "OK"
const markInputValid = ( inputElement ) => {
  inputElement.classList.remove(CLASS_NAME_ERROR)  
  inputElement.classList.add(CLASS_NAME_OK)
  const group = inputElement.closest(FORM_GROUP_SELECTOR)
  if (group) {
    group.classList.remove(CLASS_NAME_ERROR)  
    group.classList.add(CLASS_NAME_OK)
  }
}
// odznacz element oraz rodzica jako "ERROR"
const markInputInvalid = ( inputElement ) => {
  inputElement.classList.remove(CLASS_NAME_OK)  
  inputElement.classList.add(CLASS_NAME_ERROR)
  const group = inputElement.closest(FORM_GROUP_SELECTOR)
  if (group) {
    group.classList.remove(CLASS_NAME_OK)  
    group.classList.add(CLASS_NAME_ERROR)
  }
}

// 
const onFormSubmitClick = (e) => {
  const form = e.currentTarget.closest("form")
  if (!validateGroup(form)) {
    return false
  }
}

// Waliduje grupę pól
export const validateGroup = ( wrapper ) => {
  let isValid = true
  const list = getInputElements(wrapper)
  list.forEach((el, index) => {
    if (!validateInput(el)) {
      isValid = false
      markInputInvalid(el)
    } else {
      markInputValid(el)
    }
  })
  return isValid
}

// JS form validation
export const initFormValidation = () => {
  $("body").on("click", "form *[type=submit]", onFormSubmitClick)
}